import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/logos/sidebarlogo.png'


const _hoisted_1 = { class: "logo backdrop-blur-xl bg-white dark:bg-[#0c1427]/95 border-b border-gray-200/60 dark:border-[#172036]/60 px-[28px] pt-[22px] pb-[18px] absolute z-[10001] right-0 top-0 left-0 shadow-sm" }
const _hoisted_2 = { class: "h-[calc(100vh-92px)] mt-[92px] px-[20px] pb-[20px] overflow-y-auto custom-scrollbar" }
const _hoisted_3 = { class: "section-group" }
const _hoisted_4 = { class: "section-content transition-all duration-300 ease-in-out overflow-hidden" }
const _hoisted_5 = {
  key: 0,
  class: "nav-item-container"
}
const _hoisted_6 = { class: "title font-medium" }
const _hoisted_7 = {
  key: 1,
  class: "nav-item-container"
}
const _hoisted_8 = { class: "title font-medium" }
const _hoisted_9 = { class: "section-group" }
const _hoisted_10 = {
  class: "font-semibold uppercase text-[11px] tracking-wider",
  style: {"color":"#6b7280"}
}
const _hoisted_11 = { class: "nav-item-container" }
const _hoisted_12 = { class: "title font-medium" }
const _hoisted_13 = { class: "nav-item-container" }
const _hoisted_14 = { class: "title font-medium" }
const _hoisted_15 = { class: "nav-item-container" }
const _hoisted_16 = { class: "title font-medium" }
const _hoisted_17 = { class: "nav-item-container" }
const _hoisted_18 = { class: "title font-medium" }
const _hoisted_19 = { class: "section-group" }
const _hoisted_20 = {
  class: "font-semibold uppercase text-[11px] tracking-wider",
  style: {"color":"#6b7280"}
}
const _hoisted_21 = { class: "nav-item-container" }
const _hoisted_22 = { class: "title font-medium" }
const _hoisted_23 = { class: "section-group" }
const _hoisted_24 = {
  class: "font-semibold uppercase text-[11px] tracking-wider",
  style: {"color":"#6b7280"}
}
const _hoisted_25 = {
  key: 0,
  class: "nav-item-container"
}
const _hoisted_26 = {
  class: "nav-item toggle group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/8 hover:to-[#AF52DE]/8 dark:hover:from-[#5856D6]/12 dark:hover:to-[#AF52DE]/12 hover: hover:shadow-[#5856D6]/10 active:scale-[0.98]",
  type: "button"
}
const _hoisted_27 = { class: "title font-medium" }
const _hoisted_28 = { class: "accordion-collapse hidden mt-2 ltr:ml-12 rtl:mr-12 space-y-1" }
const _hoisted_29 = { class: "sidemenu-item" }
const _hoisted_30 = { class: "text-sm" }
const _hoisted_31 = { class: "sidemenu-item" }
const _hoisted_32 = { class: "text-sm" }
const _hoisted_33 = { class: "sidemenu-item" }
const _hoisted_34 = { class: "text-sm" }
const _hoisted_35 = { class: "sidemenu-item" }
const _hoisted_36 = { class: "text-sm" }
const _hoisted_37 = {
  key: 1,
  class: "nav-item-container"
}
const _hoisted_38 = {
  class: "nav-item toggle group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/8 hover:to-[#AF52DE]/8 dark:hover:from-[#5856D6]/12 dark:hover:to-[#AF52DE]/12 hover: hover:shadow-[#5856D6]/10 active:scale-[0.98]",
  type: "button"
}
const _hoisted_39 = { class: "title font-medium" }
const _hoisted_40 = { class: "accordion-collapse hidden mt-2 ltr:ml-12 rtl:mr-12 space-y-1" }
const _hoisted_41 = { class: "sidemenu-item" }
const _hoisted_42 = { class: "text-sm" }
const _hoisted_43 = { class: "sidemenu-item" }
const _hoisted_44 = { class: "text-sm" }
const _hoisted_45 = { class: "sidemenu-item" }
const _hoisted_46 = { class: "text-sm" }
const _hoisted_47 = { class: "sidemenu-item" }
const _hoisted_48 = { class: "text-sm" }
const _hoisted_49 = { class: "sidemenu-item" }
const _hoisted_50 = { class: "text-sm" }
const _hoisted_51 = {
  key: 2,
  class: "nav-item-container"
}
const _hoisted_52 = {
  class: "nav-item toggle group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/8 hover:to-[#AF52DE]/8 dark:hover:from-[#5856D6]/12 dark:hover:to-[#AF52DE]/12 hover: hover:shadow-[#5856D6]/10 active:scale-[0.98]",
  type: "button"
}
const _hoisted_53 = { class: "title font-medium" }
const _hoisted_54 = { class: "accordion-collapse hidden mt-2 ltr:ml-12 rtl:mr-12 space-y-1" }
const _hoisted_55 = { class: "sidemenu-item" }
const _hoisted_56 = { class: "text-sm" }
const _hoisted_57 = { class: "sidemenu-item" }
const _hoisted_58 = { class: "text-sm" }
const _hoisted_59 = { class: "section-group" }
const _hoisted_60 = { class: "section-header flex items-center mb-4 px-2" }
const _hoisted_61 = {
  class: "font-semibold uppercase text-[11px] tracking-wider",
  style: {"color":"#6b7280"}
}
const _hoisted_62 = { class: "space-y-2" }
const _hoisted_63 = { class: "nav-item-container" }
const _hoisted_64 = { class: "title font-medium" }
const _hoisted_65 = { class: "nav-item-container" }
const _hoisted_66 = { class: "title font-medium" }
const _hoisted_67 = { class: "accordion-collapse mt-2 ltr:ml-12 rtl:mr-12 space-y-1" }
const _hoisted_68 = { class: "sidemenu-item" }
const _hoisted_69 = { class: "text-sm" }
const _hoisted_70 = { class: "sidemenu-item hidden sm:block" }
const _hoisted_71 = { class: "text-sm" }
const _hoisted_72 = { class: "sidemenu-item hidden sm:block" }
const _hoisted_73 = { class: "text-sm" }
const _hoisted_74 = { class: "sidemenu-item hidden sm:block" }
const _hoisted_75 = { class: "text-sm" }
const _hoisted_76 = { class: "sidemenu-item" }
const _hoisted_77 = { class: "text-sm" }
const _hoisted_78 = { class: "sidemenu-item" }
const _hoisted_79 = { class: "text-sm" }
const _hoisted_80 = { class: "section-group mt-8" }
const _hoisted_81 = {
  class: "font-semibold uppercase text-[11px] tracking-wider",
  style: {"color":"#6b7280"}
}
const _hoisted_82 = { class: "nav-item-container" }
const _hoisted_83 = { class: "title font-medium group-hover:text-[#FF6B6B] dark:group-hover:text-[#FF6B6B] transition-colors" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref: "sidebarRef",
      class: _normalizeClass([
      'fixed sidebar-area backdrop-blur-xl bg-white dark:bg-[#0c1427]/95 z-[10000] top-0 h-screen rounded-r-[20px] shadow-2xl shadow-black/10 dark:shadow-black/30 border-r border-gray-200/50 dark:border-gray-700/50',
      { active: _ctx.stateStoreInstance.open },
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_RouterLink, {
          to: "/dashboard/crm",
          class: "transition-all duration-300 relative flex items-center justify-center group"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "logo",
                class: "h-8 w-auto transition-all duration-300"
              })
            ], -1)
          ])),
          _: 1,
          __: [5]
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock("div", {
          class: "accordion space-y-6",
          key: `${_ctx.locale.toString()}-${_ctx.forceRerender}`
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.shouldShowEcommerceDashboard)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_RouterLink, {
                      to: "/dashboard",
                      class: "nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#007AFF] dark:hover:text-[#007AFF] active:scale-[0.98]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _cache[6] || (_cache[6] = _createElementVNode("div", {
                          class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center ltr:mr-3 rtl:ml-3",
                          style: {"background":"linear-gradient(135deg, #007aff 0%, #5856d6 100%)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ri-shopping-cart-line text-[20px] transition-all duration-300 group-hover:scale-110",
                            style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.directT("sidebar.ecommerce")), 1),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                          _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-[#007AFF]" })
                        ], -1))
                      ]),
                      _: 1,
                      __: [6,7]
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldShowCRMDashboard)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_RouterLink, {
                      to: "/dashboard/crm",
                      class: "nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#007AFF] dark:hover:text-[#007AFF] active:scale-[0.98]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _cache[8] || (_cache[8] = _createElementVNode("div", {
                          class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center ltr:mr-3 rtl:ml-3",
                          style: {"background":"linear-gradient(135deg, #007aff 0%, #5856d6 100%)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ri-team-line text-[20px] transition-all duration-300 group-hover:scale-110",
                            style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.directT("sidebar.dashboard")), 1),
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                          _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-[#007AFF]" })
                        ], -1))
                      ]),
                      _: 1,
                      __: [8,9]
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "section-header flex items-center mb-4 px-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 rounded-lg py-2 transition-colors duration-200",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSectionCollapse('apps')))
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("div", {
                class: "w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3",
                style: {"background":"linear-gradient(to bottom, #34c759 0%, #30d158 100%)"}
              }, null, -1)),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.directT("sidebar.apps")), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["section-content space-y-2 transition-all duration-300 ease-in-out overflow-hidden", { 'collapsed': _ctx.sectionCollapsed.apps }])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_RouterLink, {
                  to: "/apps/to-do-list",
                  class: "nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#34C759] dark:hover:text-[#34C759] active:scale-[0.98]",
                  onClick: _ctx.handleNavigation
                }, {
                  default: _withCtx(() => [
                    _cache[11] || (_cache[11] = _createElementVNode("div", {
                      class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center ltr:mr-3 rtl:ml-3",
                      style: {"background":"linear-gradient(135deg, #34c759 0%, #30d158 100%)"}
                    }, [
                      _createElementVNode("i", {
                        class: "ri-checkbox-circle-line text-[20px] transition-all duration-300 group-hover:scale-110",
                        style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.directT("sidebar.todoList")), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                      _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-[#34C759]" })
                    ], -1))
                  ]),
                  _: 1,
                  __: [11,12]
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_RouterLink, {
                  to: "/apps/calendar",
                  class: "nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#34C759] dark:hover:text-[#34C759] active:scale-[0.98]",
                  onClick: _ctx.handleNavigation
                }, {
                  default: _withCtx(() => [
                    _cache[13] || (_cache[13] = _createElementVNode("div", {
                      class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center ltr:mr-3 rtl:ml-3",
                      style: {"background":"linear-gradient(135deg, #34c759 0%, #30d158 100%)"}
                    }, [
                      _createElementVNode("i", {
                        class: "ri-calendar-event-line text-[20px] transition-all duration-300 group-hover:scale-110",
                        style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.directT("sidebar.calendar")), 1),
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                      _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-[#34C759]" })
                    ], -1))
                  ]),
                  _: 1,
                  __: [13,14]
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_RouterLink, {
                  to: "/apps/chat",
                  class: "nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#34C759] dark:hover:text-[#34C759] active:scale-[0.98]",
                  onClick: _ctx.handleNavigation
                }, {
                  default: _withCtx(() => [
                    _cache[15] || (_cache[15] = _createElementVNode("div", {
                      class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                      style: {"background":"linear-gradient(135deg, #34c759 0%, #30d158 100%)","box-shadow":"0 8px 32px rgba(52, 199, 89, 0.3),\n                      inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
                    }, [
                      _createElementVNode("i", {
                        class: "ri-message-3-line text-[20px] transition-all duration-300 group-hover:scale-110",
                        style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.directT("sidebar.chat")), 1),
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                      _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-[#34C759]" })
                    ], -1))
                  ]),
                  _: 1,
                  __: [15,16]
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_RouterLink, {
                  to: "/apps/contacts",
                  class: "nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#34C759] dark:hover:text-[#34C759] active:scale-[0.98]",
                  onClick: _ctx.handleNavigation
                }, {
                  default: _withCtx(() => [
                    _cache[17] || (_cache[17] = _createElementVNode("div", {
                      class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                      style: {"background":"linear-gradient(135deg, #34c759 0%, #30d158 100%)","box-shadow":"0 8px 32px rgba(52, 199, 89, 0.3),\n                      inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
                    }, [
                      _createElementVNode("i", {
                        class: "ri-user-heart-line text-[20px] transition-all duration-300 group-hover:scale-110",
                        style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.directT("sidebar.contacts")), 1),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                      _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-[#34C759]" })
                    ], -1))
                  ]),
                  _: 1,
                  __: [17,18]
                }, 8, ["onClick"])
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "section-header flex items-center mb-4 px-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 rounded-lg py-2 transition-colors duration-200",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSectionCollapse('aiAgents')))
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("div", {
                class: "w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3",
                style: {"background":"linear-gradient(to bottom, #ff3b30 0%, #ff9500 100%)"}
              }, null, -1)),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.directT("sidebar.aiAgents")), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["section-content transition-all duration-300 ease-in-out overflow-hidden", { 'collapsed': _ctx.sectionCollapsed.aiAgents }])
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_RouterLink, {
                  to: "/bots",
                  class: "nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#FF3B30] dark:hover:text-[#FF3B30] hover:bg-gradient-to-r hover:from-[#FF3B30]/8 hover:to-[#FF9500]/8 dark:hover:from-[#FF3B30]/12 dark:hover:to-[#FF9500]/12 hover: hover:shadow-[#FF3B30]/10 active:scale-[0.98]",
                  onClick: _ctx.handleNavigation
                }, {
                  default: _withCtx(() => [
                    _cache[20] || (_cache[20] = _createElementVNode("div", {
                      class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                      style: {"background":"linear-gradient(135deg, #ff3b30 0%, #ff9500 100%)","box-shadow":"0 8px 32px rgba(255, 59, 48, 0.3),\n                    inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
                    }, [
                      _createElementVNode("i", {
                        class: "ri-brain-line text-[20px] transition-all duration-300 group-hover:scale-110",
                        style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.directT("sidebar.myAgents")), 1),
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                      _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-[#FF3B30]" })
                    ], -1))
                  ]),
                  _: 1,
                  __: [20,21]
                }, 8, ["onClick"])
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: "section-header flex items-center mb-4 px-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 rounded-lg py-2 transition-colors duration-200",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSectionCollapse('pages')))
            }, [
              _cache[22] || (_cache[22] = _createElementVNode("div", {
                class: "w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3",
                style: {"background":"linear-gradient(to bottom, #5856d6 0%, #af52de 100%)"}
              }, null, -1)),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.directT("sidebar.pages")), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["section-content space-y-2 transition-all duration-300 ease-in-out overflow-hidden", { 'collapsed': _ctx.sectionCollapsed.pages }])
            }, [
              (_ctx.shouldShowEcommerceMenu)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("button", _hoisted_26, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", {
                        class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                        style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)","box-shadow":"0 8px 32px rgba(88, 86, 214, 0.3),\n                      inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
                      }, [
                        _createElementVNode("i", {
                          class: "ri-store-3-line text-[20px] transition-all duration-300 group-hover:scale-110",
                          style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.directT("sidebar.ecommerce")), 1),
                      _cache[24] || (_cache[24] = _createElementVNode("i", {
                        class: "ri-arrow-down-s-line text-[16px] ltr:ml-auto rtl:mr-auto transition-transform duration-300 group-hover:text-[#5856D6]",
                        style: {"color":"#9ca3af"}
                      }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/products-grid",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[25] || (_cache[25] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-grid-line text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.directT("sidebar.productsGrid")), 1)
                          ]),
                          _: 1,
                          __: [25]
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/products-list",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[26] || (_cache[26] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-list-check text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.directT("sidebar.productsList")), 1)
                          ]),
                          _: 1,
                          __: [26]
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_RouterLink, {
                          to: "/crm/customers",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[27] || (_cache[27] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-user-line text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.directT("sidebar.customers")), 1)
                          ]),
                          _: 1,
                          __: [27]
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/orders",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[28] || (_cache[28] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-shopping-bag-line text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.directT("sidebar.orders")), 1)
                          ]),
                          _: 1,
                          __: [28]
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldShowCRMMenu)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("button", _hoisted_38, [
                      _cache[29] || (_cache[29] = _createElementVNode("div", {
                        class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                        style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)","box-shadow":"0 8px 32px rgba(88, 86, 214, 0.3),\n                      inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
                      }, [
                        _createElementVNode("i", {
                          class: "ri-user-settings-line text-[20px] transition-all duration-300 group-hover:scale-110",
                          style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.directT("sidebar.crm")), 1),
                      _cache[30] || (_cache[30] = _createElementVNode("i", {
                        class: "ri-arrow-down-s-line text-[16px] ltr:ml-auto rtl:mr-auto transition-transform duration-300 group-hover:text-[#5856D6]",
                        style: {"color":"#9ca3af"}
                      }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_RouterLink, {
                          to: "/crm/leads",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[31] || (_cache[31] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-user-add-line text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.directT("sidebar.leads")), 1)
                          ]),
                          _: 1,
                          __: [31]
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_RouterLink, {
                          to: "/crm/customers",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[32] || (_cache[32] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-team-line text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.directT("sidebar.customers")), 1)
                          ]),
                          _: 1,
                          __: [32]
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_RouterLink, {
                          to: "/crm/deals",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[33] || (_cache[33] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-briefcase-line text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.directT("sidebar.deals")), 1)
                          ]),
                          _: 1,
                          __: [33]
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/products-grid",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[34] || (_cache[34] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-grid-line text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.directT("sidebar.productsGrid")), 1)
                          ]),
                          _: 1,
                          __: [34]
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/products-list",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[35] || (_cache[35] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-list-check text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.directT("sidebar.productsList")), 1)
                          ]),
                          _: 1,
                          __: [35]
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldShowRealEstateMenu)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("button", _hoisted_52, [
                      _cache[36] || (_cache[36] = _createElementVNode("div", {
                        class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                        style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)","box-shadow":"0 8px 32px rgba(88, 86, 214, 0.3),\n                      inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
                      }, [
                        _createElementVNode("i", {
                          class: "ri-home-heart-line text-[20px] transition-all duration-300 group-hover:scale-110",
                          style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.directT("sidebar.realEstate")), 1),
                      _cache[37] || (_cache[37] = _createElementVNode("i", {
                        class: "ri-arrow-down-s-line text-[16px] ltr:ml-auto rtl:mr-auto transition-transform duration-300 group-hover:text-[#5856D6]",
                        style: {"color":"#9ca3af"}
                      }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_RouterLink, {
                          to: "/real-estate/property-list",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[38] || (_cache[38] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-home-line text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.directT("sidebar.propertyList")), 1)
                          ]),
                          _: 1,
                          __: [38]
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_RouterLink, {
                          to: "/real-estate/add-property",
                          class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _cache[39] || (_cache[39] = _createElementVNode("div", {
                              class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                              style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)"}
                            }, [
                              _createElementVNode("i", {
                                class: "ri-home-2-line text-[14px] transition-all duration-300",
                                style: {"color":"#ffffff"}
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.directT("sidebar.addProperty")), 1)
                          ]),
                          _: 1,
                          __: [39]
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _cache[40] || (_cache[40] = _createElementVNode("div", {
                class: "w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3",
                style: {"background":"linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)"}
              }, null, -1)),
              _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.directT("sidebar.others")), 1)
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createVNode(_component_RouterLink, {
                  to: "/members",
                  class: "nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/8 hover:to-[#FFCC02]/8 dark:hover:from-[#FF9500]/12 dark:hover:to-[#FFCC02]/12 hover: hover:shadow-[#FF9500]/10 active:scale-[0.98]",
                  onClick: _ctx.handleNavigation
                }, {
                  default: _withCtx(() => [
                    _cache[41] || (_cache[41] = _createElementVNode("div", {
                      class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                      style: {"background":"linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)","box-shadow":"0 8px 32px rgba(255, 149, 0, 0.3),\n                      inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
                    }, [
                      _createElementVNode("i", {
                        class: "ri-group-line text-[20px] transition-all duration-300 group-hover:scale-110",
                        style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.directT("sidebar.members")), 1),
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                      _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-[#FF9500]" })
                    ], -1))
                  ]),
                  _: 1,
                  __: [41,42]
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-item toggle group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/8 hover:to-[#FFCC02]/8 dark:hover:from-[#FF9500]/12 dark:hover:to-[#FFCC02]/12 hover: hover:shadow-[#FF9500]/10 active:scale-[0.98]", { open: _ctx.accordionState.settings }]),
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleAccordionMenu('settings')))
                }, [
                  _cache[43] || (_cache[43] = _createElementVNode("div", {
                    class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                    style: {"background":"linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)","box-shadow":"0 8px 32px rgba(255, 149, 0, 0.3),\n                      inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
                  }, [
                    _createElementVNode("i", {
                      class: "ri-tools-line text-[20px] transition-all duration-300 group-hover:scale-110",
                      style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                    })
                  ], -1)),
                  _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.directT("common.settings")), 1),
                  _createElementVNode("i", {
                    class: _normalizeClass(["ri-arrow-down-s-line text-[16px] ltr:ml-auto rtl:mr-auto transition-transform duration-300 group-hover:text-[#FF9500]", { 'rotate-180': _ctx.accordionState.settings }]),
                    style: {"color":"#9ca3af"}
                  }, null, 2)
                ], 2),
                _withDirectives(_createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_RouterLink, {
                      to: "/settings/connections",
                      class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _cache[44] || (_cache[44] = _createElementVNode("div", {
                          class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                          style: {"background":"linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ri-link text-[14px] transition-all duration-300",
                            style: {"color":"#ffffff"}
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.directT("sidebar.connections")), 1)
                      ]),
                      _: 1,
                      __: [44]
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_RouterLink, {
                      to: "/settings/leads-settings",
                      class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _cache[45] || (_cache[45] = _createElementVNode("div", {
                          class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                          style: {"background":"linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ri-user-add-line text-[14px] transition-all duration-300",
                            style: {"color":"#ffffff"}
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.directT("sidebar.leadsSettings")), 1)
                      ]),
                      _: 1,
                      __: [45]
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createVNode(_component_RouterLink, {
                      to: "/settings/customers-settings",
                      class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _cache[46] || (_cache[46] = _createElementVNode("div", {
                          class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                          style: {"background":"linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ri-team-line text-[14px] transition-all duration-300",
                            style: {"color":"#ffffff"}
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.directT("sidebar.customersSettings")), 1)
                      ]),
                      _: 1,
                      __: [46]
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createVNode(_component_RouterLink, {
                      to: "/settings/deals-settings",
                      class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _cache[47] || (_cache[47] = _createElementVNode("div", {
                          class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                          style: {"background":"linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ri-briefcase-line text-[14px] transition-all duration-300",
                            style: {"color":"#ffffff"}
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.directT("sidebar.dealsSettings")), 1)
                      ]),
                      _: 1,
                      __: [47]
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createVNode(_component_RouterLink, {
                      to: "/settings/account-settings",
                      class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _cache[48] || (_cache[48] = _createElementVNode("div", {
                          class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                          style: {"background":"linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ri-user-settings-line text-[14px] transition-all duration-300",
                            style: {"color":"#ffffff"}
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.directT("sidebar.accountSettings")), 1)
                      ]),
                      _: 1,
                      __: [48]
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createVNode(_component_RouterLink, {
                      to: "/settings/api-settings",
                      class: "submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _cache[49] || (_cache[49] = _createElementVNode("div", {
                          class: "w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3",
                          style: {"background":"linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ri-key-2-line text-[14px] transition-all duration-300",
                            style: {"color":"#ffffff"}
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.directT("sidebar.apiSettings")), 1)
                      ]),
                      _: 1,
                      __: [49]
                    }, 8, ["onClick"])
                  ])
                ], 512), [
                  [_vShow, _ctx.accordionState.settings]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", {
              class: "section-header flex items-center mb-4 px-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 rounded-lg py-2 transition-colors duration-200",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSectionCollapse('account')))
            }, [
              _cache[50] || (_cache[50] = _createElementVNode("div", {
                class: "w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3",
                style: {"background":"linear-gradient(to bottom, #ff3b30 0%, #ff6b6b 100%)"}
              }, null, -1)),
              _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.directT("sidebar.account")), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["section-content space-y-2 transition-all duration-300 ease-in-out overflow-hidden", { 'collapsed': _ctx.sectionCollapsed.account }])
            }, [
              _createElementVNode("div", _hoisted_82, [
                _createVNode(_component_RouterLink, {
                  to: "/authentication/logout",
                  class: "nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-[#FF3B30] dark:text-[#FF3B30] bg-[#FF3B30]/5 dark:bg-[#FF3B30]/10 border border-[#FF3B30]/10 dark:border-[#FF3B30]/20 hover:bg-gradient-to-r hover:from-[#FF3B30]/8 hover:to-[#FF6B6B]/8 dark:hover:from-[#FF3B30]/12 dark:hover:to-[#FF6B6B]/12 hover: hover:shadow-[#FF3B30]/10 active:scale-[0.98]",
                  onClick: _ctx.handleNavigation
                }, {
                  default: _withCtx(() => [
                    _cache[51] || (_cache[51] = _createElementVNode("div", {
                      class: "icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3 border border-[#FF3B30]/20 dark:border-[#FF3B30]/30",
                      style: {"background":"linear-gradient(135deg, #ff3b30 0%, rgb(228, 82, 82) 100%)","box-shadow":"0 8px 32px rgba(255, 59, 48, 0.3),\n                      inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
                    }, [
                      _createElementVNode("i", {
                        class: "ri-door-open-line text-[20px] transition-all duration-300 group-hover:scale-110",
                        style: {"color":"#ffffff","text-shadow":"0 2px 4px rgba(0, 0, 0, 0.2)"}
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.directT("common.logout")), 1),
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, [
                      _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-[#FF3B30]" })
                    ], -1))
                  ]),
                  _: 1,
                  __: [51,52]
                }, 8, ["onClick"])
              ])
            ], 2)
          ])
        ]))
      ])
    ], 2),
    (!_ctx.stateStoreInstance.open && _ctx.isMobile() && !_ctx.isCalendarPage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
      'swipe-indicator fixed top-1/2 -translate-y-1/2 z-[6] h-20 w-1.5 rounded-r-lg transition-opacity ',
      _ctx.isRTL ? 'right-0' : 'left-0',
    ]),
          style: {"background":"linear-gradient(to bottom, #007aff 0%, #5856d6 100%)"}
        }, null, 2))
      : _createCommentVNode("", true)
  ], 64))
}